export { default } from './index.vue';



// WEBPACK FOOTER //
// ./packages/wxc-tag/index.js